import { Model } from 'modules/core/lib/mobx-rest'

interface ITaskType {
  id: string
  title: string
  translated_title?: string
  identifier: string
  incidence_name: string
  leave_type_id: string
  company_id: string
  folder_id: string
  folder_type: string
  folder_identifier: string
}

class TaskType extends Model<ITaskType> {
  static urlRoot() {
    return '/bookkeepers_management/tasks/task_types'
  }
}

export default TaskType
